export default __webpack_public_path__ + "static/media/pen.ddae4e99.svg";